// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3494a1f0","25":"8ed97ccb","41":"428b3c79","390":"2384ec32","578":"418a221b","584":"959bad1d","618":"6cca0056"}[chunkId] + ".chunk.js";
};